import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import Home from "@/pages/Home";
import RipOffDetector from "@/pages/RipOffDetector";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rip-off-detector" element={<RipOffDetector />} />
      </Routes>
      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
}

export default App;
